const NUMERIC_SEGMENT = /^\d+$/;

const parseVersion = (version: string): [number, number, number] | undefined => {
  const segments = version.split(".");
  if (segments.some(segment => !NUMERIC_SEGMENT.test(segment))) return undefined;
  const [major = 0, minor = 0, patch = 0] = segments.map(Number);
  return [major, minor, patch];
};

export const isVersionAtLeast = (version: string | undefined, minimum: string): boolean => {
  if (!version || version === "-") return false;

  const current = parseVersion(version);
  const required = parseVersion(minimum);
  if (!current || !required) return false;

  const gap = current
    .map((segment, position) => segment - (required[position] ?? 0))
    .find(difference => difference !== 0);
  return gap === undefined || gap > 0;
};
